<ng-container [formGroup]="templateForm">
  <mf-column [md]="4">
    <mf-field-text formControlName="subject" />
  </mf-column>
</ng-container>
